// extracted by mini-css-extract-plugin
export var biggerImage = "FungiFact-module--bigger-image--F+bkU";
export var chaga = "FungiFact-module--chaga--gKyi9";
export var container = "FungiFact-module--container--LR9J7";
export var list = "FungiFact-module--list--AkzQL";
export var smallerImage = "FungiFact-module--smaller-image--T-vaa";
export var title = "FungiFact-module--title--rzgG0";
export var wrapper = "FungiFact-module--wrapper--5SPpQ";